import React from 'react';
import { Box } from '@chakra-ui/react';

import { PayPalFormPropTypes } from './paypal.prop-types';

import type { PayPalFormProps } from './paypal.types';

const PayPalForm = React.forwardRef((props: PayPalFormProps, forwardRef: any) => (
  <div ref={forwardRef}>
    <Box>
      You will be redirected to PayPal payment screen after confirming the reservation.
    </Box>
  </div>
));

PayPalForm.propTypes = PayPalFormPropTypes;

export { PayPalForm };
